<template>
  <div
    class="cbg-white-container blog-listing-main input-container theme--light v-card p-16 border-card pt-0"
  >
    <v-tabs v-model="tabs" background-color="transparent" class="border-bottom theme--light v-card">
      <v-tab
        @click="resetJoiningDate(), resetSearhblogStatus()"
        class="tabBox"
        v-for="(item, i) in items"
        :key="i"
      >{{ item.tabName }}</v-tab>
      <!-- <v-tab>Sent Messages</v-tab> -->
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <div class="row mt-3">
          <CCol sm="6" md="3">
            <label for>Search</label>
            <div class="search-div position-relative">
              <input
                class="form-control"
                placeholder="Search"
                @input="debounceSearch()"
                v-model="search"
              />
              <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
                <crossSVG />
              </div>
              <!-- <div @click="removeText()" v-if="searchText">
              <crossSolidSVG />
            </div>
            <div v-else>
              <searchSVG />
              </div>-->
            </div>
          </CCol>
          <CCol sm="6" md="3" class="datepicker pos-r">
            <label for>Date Range (Created Date)</label>
            <datepicker
              v-model="joinOnDateRange"
              @input="dateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD/MM/YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'DD/MM/YYYY'
                  "
                  v-on="inputEvents.start"
                  class="form-control pos-r"
                  placeholder="DD/MM/YYYY"
                />
                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg"
                  @click="resetJoiningDate"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg userinputcalendar pos-a">
              <calendarSVG />
            </div>
          </CCol>
          <CCol sm="6" md="3">
            <div class="position-relative">
              <label for>Blog Status</label>
              <select name id class="form-control" v-model="blogStatus">
                <option value="all">All</option>
                <option value="awaiting_approval">Awaiting Approval</option>
                <option value="published">Published</option>
                <option value="unpublished">Unpublished</option>
                <option value="rejected">Rejected</option>
                <option value="deleted">Blogs deleted by user</option>
              </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="v-icon mdi mdi-menu-down theme--light position-absolute"
                ></i>
              </span>
            </div>
          </CCol>
        </div>
        <div v-if="tabs == 0">
          <div class="user-blog-box mt-6">
            <div class="col-sm-12 row ml-0 pl-0 pr-0"></div>
            <div>
              <div
                v-if="blogList.length > 0"
                class="col-sm-12 row ml-0 mt-6 p-0 userlistTable-typ1 mb-5"
              >
                <userBlogCard
                  v-for="(blog, i) in blogList"
                  :key="i"
                  :blogDetails="blog"
                  @refreshList="getBlogList()"
                />
              </div>
              <div v-else-if="showLoader && blogList.length === 0">
                <loader v-if="showLoader"></loader>
              </div>
              <div v-else-if="isEmpty">
                <h2 class="text-center no-data-class">No Data Found</h2>
              </div>
            </div>
          </div>
          <pagination
            class="pagination-block"
            v-if="blogList.length > 0"
            :recordPerPage="recordPerPage"
            :currentPage="currentPage"
            :total="total"
            @changePage="changePage"
          />
        </div>
      </v-tab-item>

      <v-tab-item>
        <div v-if="tabs == 1">
          <blog-reports></blog-reports>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <CModal
      :show.sync="rejectModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
      class="reject-modal-box"
    >
      <CTextarea
        v-model="reasonData.rejected_reason"
        type="text"
        maxlength="150"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />

      <!-- <span class="text-danger">error reason</span> -->

      <template #header>
        <h6 class="modal-title">Reason for Reject</h6>
        <!-- <CButtonClose @click="rejectModal = false" class="text-white" /> -->
      </template>

      <template #footer>
        <v-btn @click="rejectModal = false" class="btn btn-danger">Cancel</v-btn>
        <v-btn class="btn btn-success" @click="closeRejectModal()">Submit</v-btn>
      </template>
    </CModal>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import "@/assets/scss/_blogs.scss";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const userBlogCard = () => import("@/views/blogs/userBlogs/userBlogCard");
const loader = () => import("@/components/loader.vue");
const blogReports = () => import("@/components/blogReports.vue");
const Image = () => import("@/components/image.vue");
import { pickSvg } from "@/views/SVG";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },

  data() {
    return {
      reasonData: {
        rejected_reason: ""
      },
      tabs: null,
      items: [{ tabName: "User listing Blog " }, { tabName: "Reports" }],
      isEmpty: false,
      lastSeenDateRange: {},
      joinOnDateRange: { start: "", end: "" },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      inactiveDays: { fromDateRange: 7, toDateRange: 1 },
      dateRangeActive: false,
      recordPerPage: 12,
      currentPage: 1,
      totalPage: 1,
      total: 0,
      blogList: [],
      blogType: "user",
      blogStatus: "all",
      search: "",
      showLoader: false,
      isEmpty: false,
      reasonModal: false,
      rejectModal: false,
      rejected_reason: "",
      blogToBeRejected: null
    };
  },
  mounted() {
    if (!!this.$route.params.tag) {
      this.search = this.$route.params.tag;
      this.getBlogList();
    } else {
      this.getBlogList();
    }
  },
  watch: {
    blogStatus: {
      handler(newValue) {
        this.blogList = [];
        this.getBlogList();
      }
    },
    blogType: {
      handler(newValue) {
        this.blogList = [];
        this.getBlogList();
      }
    }
  },

  components: {
    loader,
    userBlogCard,
    Datepicker,
    "image-view": Image,
    pagination: () => import("@/views/common/Pagination"),
    ...pickSvg("crossSVG"),
    blogReports
  },
  methods: {
    closeRejectModal() {
      this.rejectModal = false;
      this.rejectBlog("reject", this.blogToBeRejected);
      this.blogToBeRejected = null;
    },

    openRejectModal(blogDetails) {
      this.rejectModal = true;
      this.blogToBeRejected = blogDetails;
    },

    resetSearhblogStatus() {
      this.blogStatus = "all";
      this.search = "";
    },
    refreshBlogList() {
      blogList = [];
      this.getBlogList();
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getBlogList();
    },
    getDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },
    getPath() {
      this.$router.push(`/user-blog-details`);
    },
    debounceSearch: debounce(function() {
      this.getBlogList();
    }, 500),

    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.getBlogList();
    },
    resetActiveDate() {
      this.lastSeenDateRange = {};
      if (this.durationFilter) {
        this.fromDate = dayjs()
          .subtract(7, "d")
          .toISOString();
        this.toDate = dayjs()
          .subtract(0, "d")
          .toISOString();
      }
      this.getBlogList();
    },
    // for date range filter call
    dateChange() {
      this.getBlogList();
    },
    getBlogList() {
      this.showLoader = true;
      this.total = 0;
      let url = `${config.BASE_URL}api/v2/admin/blogs`;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        blog_type: this.blogType,
        blog_status: this.blogStatus,
        reason: this.rejected_reason,
        search: this.search,
        start_date: this.joinOnDateRange.start.toString(),
        end_date: this.joinOnDateRange.end.toString()
      };

      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;

          if (response.body.data.list.length) {
            this.blogList = response.body.data.list;
            this.totalPage = response.body.data.count / this.recordPerPage;
            if (response.body.data.count % this.recordPerPage !== 0)
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.count;
          } else {
            this.blogList = [];
            this.isEmpty = true;
          }
        }
      });
    },
    openSwal(status, blogDetails) {
      if (status === "Approve & Publish") {
        Swal.fire({
          title: "Are you sure you want to Approve & Publish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.ApprovePublishBlog(status, blogDetails);
          }
        });
      } else if (status === "publish") {
        Swal.fire({
          title: "Are you sure you want to Publish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.ApprovePublishBlog(status, blogDetails);
          }
        });
      } else {
        Swal.fire({
          title: "Are you sure you want to Unpublish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.updateBlog(status, blogDetails);
          }
        });
      }
    },
    ApprovePublishBlog(status, blogDetails) {
      let obj;
      if (status === "Approve & Publish" || status === "publish") {
        obj = {
          title: blogDetails.title,
          cover_photo: blogDetails.cover_photo,
          short_description: blogDetails.short_description,
          description: blogDetails.description,
          tags: blogDetails.tags,
          status: "publish"
        };
      } else {
        obj = {
          is_deleted: true
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/blogs/${blogDetails._id}/approve`;
      this.$http.put(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "Approve & Publish") {
            Swal.fire({
              title: "Blog Approved and Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else if (status === "publish") {
            Swal.fire({
              title: "Blog Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else {
            Swal.fire({
              title: "Blog Saved Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          }
        }
      });
    },
    clearSearch() {
      this.search = "";
    },
    rejectBlog(status, blogDetails) {
      var obj = null;
      if (status === "reject") {
        obj = {
          reason: this.reasonData.rejected_reason,
          blog_type: "user"
        };
      } else {
        obj = {
          is_deleted: true
        };
      }

      let url = `${config.BASE_URL}api/v2/admin/blogs/${blogDetails._id}/reject`;
      this.$http.put(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "reject") {
            Swal.fire({
              title: "Blog Rejected",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else {
            Swal.fire({
              title: "Blog Saved Successfully",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          }
        }
      });
    },
    updateBlog(status, blogDetails) {
      let obj;
      if (status === "unpublish") {
        obj = {
          title: blogDetails.title,
          cover_photo: blogDetails.cover_photo,
          blog_type: "user",
          short_description: blogDetails.short_description,
          description: blogDetails.description,
          tags: blogDetails.tags,
          status: status
        };
      } else {
        obj = {
          is_deleted: true
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/blogs/${blogDetails._id}`;
      this.$http.post(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "unpublish") {
            Swal.fire({
              title: "Blog Unpublished Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else {
            Swal.fire({
              title: "Blog Saved Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          }
        }
      });
    },

    goTo(url) {
      this.$router.push(url);
    }
  }
};
</script>